import React, { ChangeEventHandler } from 'react';

import FormInvalid from './FormInvalid';
import { SelectOptions } from './Select';

type Props = {
    field: string;
    value: string | number;
    label: string | JSX.Element;
    options: SelectOptions | number[];
    error: string;
    optionAccessor?: string;
    optionValueAccessor?: string;
    handleChange: ChangeEventHandler<HTMLSelectElement>;
    required?: boolean;
    disabled?: boolean;
    optionAsValue?: boolean;
    inputClasses?: string;
};

function AdvancedSelect({
    field,
    value,
    label,
    options,
    error,
    handleChange,
    required = false,
    disabled = false,
    optionAsValue = false,
    optionAccessor,
    optionValueAccessor,
    inputClasses = '',
}: Props) {
    const hasError = (error ?? false) !== false;

    return (
        <div className="form-group">
            <label htmlFor={field}>
                {label} {required && required === true && <span className="text-danger text-sm">*</span>}
            </label>
            <select
                id={field}
                className={`form-control ${hasError ? 'is-invalid' : ''} ${inputClasses}`}
                name={field}
                value={value}
                onChange={handleChange}
                required={required}
                disabled={disabled}
            >
                {!required && (
                    <option key={-1} value="0">
                        {'\u2014'}
                    </option>
                )}

                {Object.keys(options).map((key) => {
                    let optionValue = key;

                    if (optionValueAccessor) {
                        optionValue = options[key][optionValueAccessor];
                    } else if (optionAsValue) {
                        optionValue = options[key];
                    }

                    return (
                        <option key={key} value={optionValue}>
                            {optionAccessor ? options[key][optionAccessor] : options[key]}
                        </option>
                    );
                })}
            </select>
            {hasError && <FormInvalid message={error} />}
        </div>
    );
}

export default AdvancedSelect;
